// ── Active section ──

export type NavSection = 'predictionMarkets' | 'futures' | 'rewards';

/** The header nav entry a locale-less path belongs to, if any. */
export function sectionFromPath(pathname: string): NavSection | null {
  if (pathname.startsWith('/rewards')) return 'rewards';
  if (pathname.startsWith('/trade')) return 'futures';
  if (pathname === '/' || pathname.startsWith('/event') || pathname.startsWith('/markets')) {
    return 'predictionMarkets';
  }
  return null;
}

// ── Scroll edges of the nav bar ──

export interface ScrollEdges {
  start: boolean;
  end: boolean;
}

export const NO_OVERFLOW: ScrollEdges = { start: false, end: false };

const SCROLL_STEP_PX = 120;

/** Which ends of a horizontally scrolling list have content cut off. */
export function readEdges(list: HTMLElement): ScrollEdges {
  return {
    start: list.scrollLeft > 1,
    end: list.scrollLeft + list.clientWidth < list.scrollWidth - 1,
  };
}

/** Keeps the previous object when nothing changed, so a scroll doesn't re-render. */
export function sameEdges(prev: ScrollEdges, next: ScrollEdges): ScrollEdges {
  return prev.start === next.start && prev.end === next.end ? prev : next;
}

export function scrollNav(list: HTMLElement | null, direction: 1 | -1) {
  list?.scrollBy({ left: direction * SCROLL_STEP_PX, behavior: 'smooth' });
}
